export const environment = {
  production: true,
  connection: {
    name: 'LH Hopfgarten Softline TEST',
    host: 'https://softline-test.lagerhaus-hopfgarten.at/',
    port: 443,
    basePath: '/api'
  },
  androidUpdateRepository: ''
};
